import React from 'react';
import PropTypes from 'prop-types';
import { FaStar } from 'react-icons/fa';
import styles from './styles.css';
import { randomKey } from '../../core/util';

const StarRating = ({
  rating = 0,
  numOfStars = 5,
  ratedColor = 'black',
  nonRatedColor = 'gray'
}) => (
  <div className="stars">
    {[...Array(rating)].map(() => (
      <FaStar color={ratedColor} key={randomKey()} />
    ))}
    {[...Array(numOfStars - rating)].map(() => (
      <FaStar color={nonRatedColor} key={randomKey()} />
    ))}
    <style jsx>{styles}</style>
  </div>
);

StarRating.propTypes = {
  rating: PropTypes.number,
  numOfStars: PropTypes.number,
  ratedColor: PropTypes.string,
  nonRatedColor: PropTypes.string
};

export default StarRating;
